module.exports = __webpack_public_path__ + "static/media/HB_cobbsalad_forweb4_edited.ffcd0aa9.jpg";